export const LANGUAGES = [
  { code: "en", label: "English", english: "English", speech: "en-IN" },
  { code: "te", label: "తెలుగు", english: "Telugu", speech: "te-IN" },
  { code: "hi", label: "हिन्दी", english: "Hindi", speech: "hi-IN" },
  { code: "kn", label: "ಕನ್ನಡ", english: "Kannada", speech: "kn-IN" },
  { code: "ta", label: "தமிழ்", english: "Tamil", speech: "ta-IN" },
  { code: "mr", label: "मराठी", english: "Marathi", speech: "mr-IN" },
];

export const COUNTRIES = [
  { code: "IN", name: "India", currency: "INR", numberLocale: "en-IN", status: "ACTIVE", dialCode: "+91", languages: ["en", "te", "hi", "kn", "ta", "mr"], taxNote: "GST treatment is set by the platform billing configuration (not verified)" },
  { code: "AE", name: "United Arab Emirates", currency: "AED", numberLocale: "en-AE", status: "FUTURE", dialCode: "+971", languages: ["en", "ar"], taxNote: "UAE VAT configuration deferred" },
];

export const IN_STATES = [
  { code: "TG", name: "Telangana", wave: 1 },
  { code: "AP", name: "Andhra Pradesh", wave: 1 },
  { code: "KA", name: "Karnataka", wave: 2 },
  { code: "TN", name: "Tamil Nadu", wave: 2 },
  { code: "MH", name: "Maharashtra", wave: 3 },
  { code: "DL", name: "Delhi NCR", wave: 3 },
  { code: "RJ", name: "Rajasthan", wave: 3 },
  { code: "OT", name: "Other India", wave: 4 },
];

export const ACTIVE_COUNTRY = COUNTRIES[0];
